import { Component, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { MainConfig } from "@atenea-cms";
import { EsportsTeamService } from "../shared";

@Component({
  selector: "esports-team-list",
  templateUrl: "./esports-team-list.component.html",
  styleUrls: ["./esports-team-list.component.scss"],
  host: { class: "atn-list-crud" },
})
export class EsportsTeamListComponent implements OnInit {
  constructor(
    private titleService: Title,
    private mainConfig: MainConfig,
    public dataService: EsportsTeamService
  ) {}

  ngOnInit() {
    this.titleService.setTitle("Equipos ESports - " + this.mainConfig.cmsName);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-teams/esports-team-list/esports-team-list.component.ts